export const generateCalendarDays = (currentDate) => {
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();
  const firstDay = new Date(year, month, 1).getDay();
  const startingDay = firstDay === 0 ? 6 : firstDay - 1;
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const daysInPrevMonth = new Date(year, month, 0).getDate();
  const days = [];

  for (let i = startingDay - 1; i >= 0; i--) {
    days.push({ 
      day: daysInPrevMonth - i, 
      currentMonth: false, 
      date: new Date(year, month - 1, daysInPrevMonth - i) 
    });
  }
  for (let i = 1; i <= daysInMonth; i++) {
    days.push({ 
      day: i, 
      currentMonth: true, 
      date: new Date(year, month, i) 
    });
  }
  const remaining = 42 - days.length;
  for (let i = 1; i <= remaining; i++) {
    days.push({ 
      day: i, 
      currentMonth: false, 
      date: new Date(year, month + 1, i) 
    });
  }
  return days;
};

export const formatDate = (d) => {
  const date = new Date(d);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};